import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import DispatcherAPI from "../../apis/dispatcherApi/dispatcherAPI";
import {toast} from "react-toastify";
import Pagination from "../assets/Pagination";
import TableLoader from "../loaders/TableLoader";

const ManagerBusManagerIndex = () => {

    const [escorteurs, setEscorteurs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    //Permet d'aller recuperer les invoices
    const fetchEscorteurs = async () => {
        try{
            const data =  await DispatcherAPI.findBusEscortors();
            setEscorteurs(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des escorteurs !");
        }
    };

    useEffect(() => {
        fetchEscorteurs();
    },[]);



    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des buses en fonction de la recherche

    const filteredEscorteurs = escorteurs.filter(
        v =>
            v.name.toLowerCase().includes(search.toLowerCase()) ||
            v.email.toLowerCase().includes(search.toLowerCase()) ||
            v.phone.toLowerCase().includes(search.toLowerCase()) ||
            v.city.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedEscorteurs = Pagination.getData(
        filteredEscorteurs,
        currentPage,
        itemsPerPage
    );



    let count = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les escorteurs</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dispatcher">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Les escorteurs de bus KKS</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total {escorteurs ? escorteurs.length : 0}</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <div className="form-group">
                                            <input type="text" onChange={handleSearch} value={search} className="form-control" placeholder="Rechercher ..." />
                                        </div>
                                    </div>
                                </div>
                                <table className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Telephone</th>
                                        <th scope="col">Ville de residence</th>
                                        <th scope="col">Options</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedEscorteurs.map((driver) => (
                                        <tr key={driver.id}>
                                            <th scope="row">{count++}</th>
                                            <td>{driver.name}</td>
                                            <td>{driver.email}</td>
                                            <td>{driver.phone}</td>
                                            <td>{driver.city}</td>

                                            <td>
                                                {/*<Link className="btn btn-sm btn-success mx-1" to={`/dispatcher/users/edit/${driver.id}`}>*/}
                                                {/*    <i className="bi bi-pen-fill"></i>*/}
                                                {/*</Link>*/}
                                            </td>
                                        </tr>
                                    ))
                                    }

                                    </tbody> }
                                </table>

                                {loading && <TableLoader width={500} height={550} />}

                                {itemsPerPage < filteredEscorteurs.length &&
                                    <Pagination
                                        currentPage={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        length={filteredEscorteurs.length}
                                        onPageChange={handleChangeCurrentPage}
                                    />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ManagerBusManagerIndex;
